import React, { ReactNode, useState } from 'react';
import css from './NewConfirmModal.module.css';
import { Button, ButtonProps } from '@mm/components';
import { ModalContainer } from '../components/ModalContainer/ModalContainer';
import { ModalCloseButton } from '../components/ModalCloseButton/ModalCloseButton';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { InfoCircleFilled } from '@ant-design/icons';
import { INewConfirmModal } from '@mm/state/modules/modalsState/props';
import { MODALS_TYPE } from '@mm/state/modules/modalsState/types';

const NewConfirmModal: React.FC<INewConfirmModal> = ({
  image,
  title = '',
  subtitle = '',
  onReject = async () => {},
  onResolve = async () => {},
  rejectButton = {},
  resolveButton = {},
  css: cssProp,
}) => {
  const [busy, setBusy] = useState(false);

  const { closeModal } = useModalActions();

  const close = () => closeModal(MODALS_TYPE.NEW_CONFIRM_MODAL);

  const handleClose = () => {
    close();
    onReject();
  };

  const handleSubmit = async () => {
    setBusy(true);
    try {
      await onResolve(close);
    } finally {
      setBusy(false);
    }
  };

  return (
    <ModalContainer className={cssProp?.container} onOutsideClick={handleClose}>
      <ModalCloseButton onClick={handleClose} />

      <div className={css.body}>
        <div className={css.figure}>
          {image ? image : <InfoCircleFilled className={css.defaultIcon} />}
        </div>

        {title && <span className={css.title}>{title}</span>}

        {subtitle && <span className={css.subtitle}>{subtitle}</span>}
      </div>

      <div className={css.footer}>
        <Button
          onClick={handleClose}
          {...rejectButton}
          color={rejectButton.color || 'link'}
          disabled={rejectButton.disabled || busy}
        >
          {rejectButton.children || 'Cancel'}
        </Button>
        <Button
          onClick={handleSubmit}
          {...resolveButton}
          disabled={resolveButton.disabled || busy}
        >
          {resolveButton.children || 'Confirm'}
        </Button>
      </div>
    </ModalContainer>
  );
};

export default NewConfirmModal;
